import React from 'react'
import { UsersAdmin } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { getUserAdminName } from 'src/core/helpers'
import { FormLabels, CustomTitle } from 'src/components'
import styles from './UserAdminMovileViewColumn.module.scss'
import UserAdminSeeDetails from '../UserAdminListActions/UserAdminSeeDetails/UserAdminSeeDetails'
import UserAdminRejectButton from '../UserAdminListActions/UserAdminRejectButton/UserAdminRejectButton'
import UserAdminValidateButton from '../UserAdminListActions/UserAdminValidateButton/UserAdminValidateButton'

const UserAdminMovileViewColumn: React.FC<{ user: UsersAdmin }> = ({ user }) => {
  const { t } = useTranslation()

  const userType = {
    individual: t('Validate.Individual'),
    business: t('Validate.Business')
  }[user.user_type]

  return <>
    <FormLabels
      title={getUserAdminName(user)}
      subtitle={user.email}
    />
    <div className={styles.content}>
      {/* User Type */}
      <CustomTitle label={userType} />
      {/* Buttons */}
      <div className='has-text-centered'>
        <UserAdminSeeDetails user={user} />
        <UserAdminValidateButton user={user} />
        <UserAdminRejectButton user={user} />
      </div>
    </div>
  </>
}

export default UserAdminMovileViewColumn
